<div class="damage-claim">
    <!-- Heading -->
    <div class="damage-claim__heading" *ngIf="claim">
        <div class="damage-claim__heading-left">
            <button
                class="btn btn--block btn--secondary"
                aria-label="Terug naar schademap"
                [routerLink]="['/verzekeringsmap/mijn-schades']"
            >
                <svg class="svg-icon svg-icon--s"><use href="assets/icons-ui.svg#links-open"></use></svg>
            </button>
        </div>
        <div class="damage-claim__heading-right">
            <h2>{{ claim.aard_schadegeval_omschrijving }}</h2>
            <p>
                {{ claim.schadedatum | dateFormat: "LL" }} om {{ claim.schadetijdstip | time }} uur, schadenummer:
                <ins-schadenummer
                    [relatie_id]="claim.relatie_id"
                    [dossier_volgnummer]="claim.dossier_volgnummer"
                ></ins-schadenummer>
            </p>
        </div>
    </div>

    <!-- Pending actions -->
    <div
        class="damage-claim__due"
        [id]="activePanelEnum.PendingActionsPanel"
        [ngClass]="{ 'damage-claim__due--actions': actions }"
    >
        <ins-pending-actions-container [children]="children" *ngIf="actions"></ins-pending-actions-container>
    </div>

    <!-- DAS claims -->
    <div class="damage-claim__das" id="das" *ngIf="showDas">
        <div class="damage-claim__das-logo">
            <span>DAS</span>
            <img
                class="image"
                width="25"
                src="/assets/default-image-1x1.png"
                lazyLoad="/assets/shared/logos/das-logo.png"
                alt="DAS Nederlandse Rechtsbijstand Verzekeringsmaatschappij N.V."
            />
        </div>
        <div class="damage-claim__das-link">
            <p>
                Ga naar Mijn
                <a href="https://inloggen.das.nl/inloggen" title="DAS dossier" target="_blank" rel="noopener nofollow">
                    DAS dossier
                </a>
                <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#rechts-open"></use></svg>
            </p>
        </div>
    </div>

    <!-- Stichting Achmea Rechtsbijstand -->
    <div class="damage-claim__das" id="sar" *ngIf="showSar">
        <div class="damage-claim__das-logo">
            <span>Achmea Rechtsbijstand</span>
            <img
                class="image"
                width="178"
                src="/assets/default-image-1x1.png"
                lazyLoad="/assets/shared/logos/logo-achmea_rechtsbijstand.png"
                alt="Stichting Achmea Rechtsbijstand"
            />
        </div>
        <div class="damage-claim__das-link">
            <p>
                Ga naar
                <a
                    href="https://www.achmearechtsbijstand.nl"
                    title="SAR dossier"
                    target="_blank"
                    rel="noopener nofollow"
                >
                    Mijn dossier
                </a>
                <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#rechts-open"></use></svg>
            </p>
        </div>
    </div>

    <!-- Details - NOT DAS -->
    <div class="damage-claim__details" *ngIf="!showDas && !showSar">
        <div class="damage-claim__detail" [id]="activePanelEnum.ClaimNotificationPanel">
            <ins-damage-claim-title
                title="Updates"
                icon="updates"
                [expand]="activePanels[activePanelEnum.ClaimNotificationPanel]"
                (openTitle)="open(activePanelEnum.ClaimNotificationPanel)"
                (closeTitle)="close(activePanelEnum.ClaimNotificationPanel)"
            ></ins-damage-claim-title>
            <!-- Expanding panel onInit does not work with activePanelEnum -->
            <ins-panel-expandable [hasBorder]="false" direction="right" [id]="activePanelEnum.ClaimNotificationPanel">
                <ins-claim-notification-container class="damage-claim__content"></ins-claim-notification-container>
            </ins-panel-expandable>
        </div>

        <div class="damage-claim__detail" [id]="activePanelEnum.AppointmentPanel">
            <ins-damage-claim-title
                title="Afspraak"
                icon="schadevrije-jaren"
                [expand]="activePanels[activePanelEnum.AppointmentPanel]"
                (openTitle)="open(activePanelEnum.AppointmentPanel)"
                (closeTitle)="close(activePanelEnum.AppointmentPanel)"
            ></ins-damage-claim-title>
            <!-- Expanding panel onInit does not work with activePanelEnum -->
            <ins-panel-expandable [hasBorder]="false" direction="right" [id]="activePanelEnum.AppointmentPanel">
                <ins-appointment-container
                    *ngIf="claim"
                    class="damage-claim__content"
                    [file_serial_number]="claim.dossier_volgnummer"
                ></ins-appointment-container>
            </ins-panel-expandable>
        </div>

        <div class="damage-claim__detail" [id]="activePanelEnum.InboxPanel">
            <ins-damage-claim-title
                title="Postvak"
                icon="mail"
                [expand]="activePanels[activePanelEnum.InboxPanel]"
                (openTitle)="open(activePanelEnum.InboxPanel)"
                (closeTitle)="close(activePanelEnum.InboxPanel)"
            ></ins-damage-claim-title>
            <!-- Expanding panel onInit does not work with activePanelEnum -->
            <ins-panel-expandable [hasBorder]="false" direction="right" [id]="activePanelEnum.InboxPanel">
                <ins-mailbox-container
                    *ngIf="claim"
                    class="damage-claim__content"
                    [file_serial_number]="claim.dossier_volgnummer"
                    [relation_id]="claim.relatie_id"
                ></ins-mailbox-container>
            </ins-panel-expandable>
        </div>

        <div class="damage-claim__detail" [id]="activePanelEnum.InvolvedPartyPanel">
            <ins-damage-claim-title
                title="Andere betrokkenen"
                icon="persoongegevens"
                [expand]="activePanels[activePanelEnum.InvolvedPartyPanel]"
                (openTitle)="open(activePanelEnum.InvolvedPartyPanel)"
                (closeTitle)="close(activePanelEnum.InvolvedPartyPanel)"
            ></ins-damage-claim-title>
            <!-- Expanding panel onInit does not work with activePanelEnum -->
            <ins-panel-expandable [hasBorder]="false" direction="right" [id]="activePanelEnum.InvolvedPartyPanel">
                <ins-involved-parties-container
                    *ngIf="claim"
                    class="damage-claim__content"
                    [file_serial_number]="claim.dossier_volgnummer"
                    [relation_id]="claim.relatie_id"
                ></ins-involved-parties-container>
            </ins-panel-expandable>
        </div>

        <div class="damage-claim__detail" [id]="activePanelEnum.PhotoPanel">
            <ins-damage-claim-title
                title="Foto's"
                icon="foto"
                [expand]="activePanels[activePanelEnum.PhotoPanel]"
                (openTitle)="open(activePanelEnum.PhotoPanel)"
                (closeTitle)="close(activePanelEnum.PhotoPanel)"
            ></ins-damage-claim-title>
            <!-- Expanding panel onInit does not work with activePanelEnum -->
            <ins-panel-expandable [hasBorder]="false" direction="right" [id]="activePanelEnum.PhotoPanel">
                <ins-photos-container
                    *ngIf="claim"
                    class="damage-claim__content"
                    [file_serial_number]="claim.dossier_volgnummer"
                ></ins-photos-container>
            </ins-panel-expandable>
        </div>

        <div class="damage-claim__detail" [id]="activePanelEnum.PaperworkPanel">
            <ins-damage-claim-title
                title="Documenten"
                icon="alle-verzekeringen"
                [expand]="activePanels[activePanelEnum.PaperworkPanel]"
                (openTitle)="open(activePanelEnum.PaperworkPanel)"
                (closeTitle)="close(activePanelEnum.PaperworkPanel)"
            ></ins-damage-claim-title>
            <!-- Expanding panel onInit does not work with activePanelEnum -->
            <ins-panel-expandable [hasBorder]="false" direction="right" [id]="activePanelEnum.PaperworkPanel">
                <ins-paperwork-container
                    *ngIf="claim"
                    class="damage-claim__content"
                    [file_serial_number]="claim.dossier_volgnummer"
                    [relation_id]="claim.relatie_id"
                ></ins-paperwork-container>
            </ins-panel-expandable>
        </div>
    </div>
    <!-- // Details -->
</div>
